export default (typeof global !== 'undefined'
    ? global
    : typeof window !== 'undefined'
        ? window
        : this);
//# sourceMappingURL=global.js.map